import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/node-infrastructure/page.tsx");
